<template>
  <header class="header">
    <slot name="logo"></slot>
    <slot name="dropdown-business"></slot>
    <slot name="menu"></slot>
    <slot name="search"></slot>
    <slot name="options"></slot>
  </header>
</template>

<script>
export default {
  data () {
    return {
      menuWidth: null
    }
  },
  mounted () {
    let that = this

    const $menu = document.getElementById('menu')
    this.menuWidth = $menu.clientWidth

    const $menuBar = document.getElementById('menuBar')
    const $menuWrapper = document.getElementById('menuWrapper')
    const $sidebar = document.querySelector('.sidebar')

    function showSidebarBar () {
      if ($sidebar.clientWidth <= that.menuWidth || window.innerWidth < 1201) {

        $menuBar.classList.add('sidebar__bar--show')
        $sidebar.classList.add('sidebar--shrink')

        $menuWrapper.classList.add('sidebar__list-wrapper')
        
      } else {
        
        $menuBar.classList.remove('sidebar__bar--show')
        $sidebar.classList.remove('sidebar--shrink')
        $menuWrapper.classList.remove('sidebar__list-wrapper')

      }
    }

    showSidebarBar()

    window.addEventListener('resize', function (event) {
      showSidebarBar()
    })
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/layout/Header.vue